module.exports = "https://static-production.npmjs.com/3dc95981de4241b35cd55fe126ab6b2c.png";